import { useDeleteSearchFilterMutation } from '@entities/search'

interface DeleteSearchFilterManagerHookProps {
  selectedSearchFilterId: number | undefined
  onDeleteSearchFilter: () => void
}

export const useDeleteSearchFilterManager = (props: DeleteSearchFilterManagerHookProps) => {
  const { selectedSearchFilterId, onDeleteSearchFilter } = props

  const [deleteSearchFilter, { isLoading: isDeletingSearchFilter }] =
    useDeleteSearchFilterMutation()

  const handleDeleteSearchFilter = () => {
    if (selectedSearchFilterId) {
      deleteSearchFilter(selectedSearchFilterId).unwrap().then(onDeleteSearchFilter)
    }
  }

  return { handleDeleteSearchFilter, isDeletingSearchFilter }
}
